import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';

import { FsMessage } from '@firestitch/message';

import { SessionService, TermsStatusService } from '@app/core';
import { TermsService } from '@app/terms/services';


@Component({
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [RouterOutlet],
})
export class TermsComponent implements OnInit {
  private _sessionService = inject(SessionService);
  private _termsStatusService = inject(TermsStatusService);
  private _router = inject(Router);
  private _route = inject(ActivatedRoute);
  private _message = inject(FsMessage);
  private _termsService = inject(TermsService);


  public ngOnInit(): void {
    const redirect = this._route.snapshot.queryParams.redirect;

    if (redirect) {
      this._termsService.redirect = redirect;
    }

    const accountId = this._sessionService.accountId();
    if (!accountId) {
      this._router.navigateByUrl('/signin');

      return;
    }

    this._termsStatusService.ensureLoaded(accountId)
      .subscribe(() => this._routeNext());
  }

  private _routeNext(): void {
    const status = this._termsStatusService.snapshot();
    if (!status) {
      return;
    }

    const skipped = this._sessionService.skippedTermTypesSet();
    const segment = this._termsStatusService.firstBlockedRelativePath(status, skipped);
    if (segment) {
      this._router.navigate([segment], { relativeTo: this._route });

      return;
    }

    this._router.navigateByUrl(this._termsService.redirect || '/');
    this._termsService.redirect = '';
    this._message.success(`Welcome ${this._sessionService.account().firstName}`);
  }

}
